import { SignalREffects } from './signalR.effects'

export * from './signalR.effects'

export const effects: any[] = [SignalREffects]



// WEBPACK FOOTER //
// ./src/app/shared/signalR/store/effects/index.ts